"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var asynciterator_1 = require("asynciterator");

var asynciterator_promiseproxy_1 = require("asynciterator-promiseproxy");

var rdf_string_1 = require("rdf-string");

var rdf_terms_1 = require("rdf-terms");
/**
 * An RDF source that executes a quad pattern over a QPF interface and fetches its first page.
 */


var RdfSourceQpf =
/*#__PURE__*/
function () {
  function RdfSourceQpf(mediatorMetadata, mediatorMetadataExtract, mediatorRdfDereference, subjectUri, predicateUri, objectUri, graphUri, metadata, context, initialQuads) {
    _classCallCheck(this, RdfSourceQpf);

    this.mediatorMetadata = mediatorMetadata;
    this.mediatorMetadataExtract = mediatorMetadataExtract;
    this.mediatorRdfDereference = mediatorRdfDereference;
    this.subjectUri = subjectUri;
    this.predicateUri = predicateUri;
    this.objectUri = objectUri;
    this.graphUri = graphUri;
    this.context = context;
    this.cachedQuads = {};
    this.searchForm = this.getSearchForm(metadata);

    if (initialQuads) {
      var wrappedQuads = asynciterator_1.AsyncIterator.wrap(initialQuads);
      wrappedQuads.setProperty('metadata', metadata);
      this.cacheQuads(wrappedQuads);
    }
  }
  /**
   * Get a first QPF search form.
   * @param {{[p: string]: any}} metadata A metadata object.
   * @return {ISearchForm} A search form, or null if none could be found.
   */


  _createClass(RdfSourceQpf, [{
    key: "getSearchForm",
    value: function getSearchForm(metadata) {
      if (!metadata.searchForms || !metadata.searchForms.values) {
        return null;
      } // Find a quad pattern or triple pattern search form


      var searchForms = metadata.searchForms; // TODO: in the future, a query-based search form getter should be used.

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = searchForms.values[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var searchForm = _step.value;

          if (this.graphUri && this.subjectUri in searchForm.mappings && this.predicateUri in searchForm.mappings && this.objectUri in searchForm.mappings && this.graphUri in searchForm.mappings && Object.keys(searchForm.mappings).length === 4) {
            return searchForm;
          }

          if (this.subjectUri in searchForm.mappings && this.predicateUri in searchForm.mappings && this.objectUri in searchForm.mappings && Object.keys(searchForm.mappings).length === 3) {
            return searchForm;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return null;
    }
    /**
     * Create a QPF fragment IRI for the given quad pattern.
     * @param {ISearchForm} searchForm A search form.
     * @param {Term} subject A term or null.
     * @param {Term} predicate A term or null.
     * @param {Term} object A term or null.
     * @param {Term} graph A term or null.
     * @return {string} A URI.
     */

  }, {
    key: "createFragmentUri",
    value: function createFragmentUri(searchForm, subject, predicate, object, graph) {
      var entries = {};
      var input = [{
        uri: this.subjectUri,
        term: subject
      }, {
        uri: this.predicateUri,
        term: predicate
      }, {
        uri: this.objectUri,
        term: object
      }, {
        uri: this.graphUri,
        term: graph
      }];

      for (var _i = 0, _input = input; _i < _input.length; _i++) {
        var entry = _input[_i];

        if (entry.uri && entry.term) {
          entries[entry.uri] = rdf_string_1.termToString(entry.term);
        }
      }

      return searchForm.getUri(entries);
    }
    /**
     * A helper function to find a hash with quad elements that have duplicate variables.
     *
     * @param {RDF.Term} subject An optional subject term.
     * @param {RDF.Term} predicate An optional predicate term.
     * @param {RDF.Term} object An optional object term.
     * @param {RDF.Term} graph An optional graph term.
     *
     * @return {{[p: string]: string[]}} If no equal variable names are present in the four terms, this returns null.
     *                                   Otherwise, this maps quad elements ('subject', 'predicate', 'object', 'graph')
     *                                   to the list of quad elements it shares a variable name with.
     *                                   If no links for a certain element exist, this element will
     *                                   not be included in the hash.
     *                                   Note 1: Quad elements will never have a link to themselves.
     *                                           So this can never occur: { subject: [ 'subject'] },
     *                                           instead 'null' would be returned.
     *                                   Note 2: Links only exist in one direction,
     *                                           this means that { subject: [ 'predicate'], predicate: [ 'subject' ] }
     *                                           will not occur, instead only { subject: [ 'predicate'] }
     *                                           will be returned.
     */

  }, {
    key: "getDuplicateElementLinks",
    value: function getDuplicateElementLinks(subject, predicate, object, graph) {
      // Collect a variable to quad elements mapping.
      var variableElements = {};
      var duplicateVariables = false;
      var input = {
        subject: subject,
        predicate: predicate,
        object: object,
        graph: graph
      };

      for (var key in input) {
        if (input[key] && input[key].termType === 'Variable') {
          var val = rdf_string_1.termToString(input[key]);
          var length = (variableElements[val] || (variableElements[val] = [])).push(key);
          duplicateVariables = duplicateVariables || length > 1;
        }
      }

      if (!duplicateVariables) {
        return null;
      } // Collect quad element to elements with equal variables mapping.


      var duplicateElementLinks = {};

      for (var variable in variableElements) {
        var elements = variableElements[variable];
        var remainingElements = elements.slice(1); // Only store the elements that have at least one equal element.

        if (remainingElements.length) {
          duplicateElementLinks[elements[0]] = remainingElements;
        }
      }

      return duplicateElementLinks;
    }
  }, {
    key: "match",
    value: function match(subject, predicate, object, graph) {
      var _this = this;

      if (subject instanceof RegExp || predicate instanceof RegExp || object instanceof RegExp || graph instanceof RegExp) {
        throw new Error("RdfSourceQpf does not support matching by regular expressions.");
      } // Try to emit from cache


      var cached = this.getCachedQuads(subject, predicate, object, graph);

      if (cached) {
        return cached;
      }

      var quads = new asynciterator_promiseproxy_1.PromiseProxyIterator(
      /*#__PURE__*/
      _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var url, rdfDereferenceOutput, rdfMetadataOuput, filteredOutput, duplicateElementLinks;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.createFragmentUri(_this.searchForm, subject, predicate, object, graph);

              case 2:
                url = _context.sent;
                _context.next = 5;
                return _this.mediatorRdfDereference.mediate({
                  context: _this.context,
                  url: url
                });

              case 5:
                rdfDereferenceOutput = _context.sent;
                url = rdfDereferenceOutput.url; // Determine the metadata and emit it

                _context.next = 9;
                return _this.mediatorMetadata.mediate({
                  context: _this.context,
                  url: url,
                  quads: rdfDereferenceOutput.quads,
                  triples: rdfDereferenceOutput.triples
                });

              case 9:
                rdfMetadataOuput = _context.sent;

                _this.mediatorMetadataExtract.mediate({
                  context: _this.context,
                  url: url,
                  metadata: rdfMetadataOuput.metadata
                }).then(function (_ref2) {
                  var metadata = _ref2.metadata;
                  quads.setProperty('metadata', metadata);
                  quads.emit('metadata', metadata);
                }); // The server is free to send any data in its response (such as metadata),
                // including quads that do not match the given matter.
                // Therefore, we have to filter away all non-matching quads here.


                filteredOutput = asynciterator_1.AsyncIterator.wrap(rdfMetadataOuput.data).filter(function (quad) {
                  return rdf_terms_1.matchPattern(quad, subject, predicate, object, graph);
                }); // Detect duplicate variables in the pattern

                duplicateElementLinks = _this.getDuplicateElementLinks(subject, predicate, object, graph); // If there are duplicate variables in the search pattern,
                // make sure that we filter out the triples that don't have equal values for those triple elements,
                // as QPF ignores variable names.

                if (duplicateElementLinks) {
                  filteredOutput = filteredOutput.filter(function (quad) {
                    // No need to check the graph, because an equal element already would have to be found in s, p, or o.
                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                      for (var _iterator2 = rdf_terms_1.TRIPLE_TERM_NAMES[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var element1 = _step2.value;
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                          for (var _iterator3 = (duplicateElementLinks[element1] || [])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var element2 = _step3.value;

                            if (!quad[element1].equals(quad[element2])) {
                              return false;
                            }
                          }
                        } catch (err) {
                          _didIteratorError3 = true;
                          _iteratorError3 = err;
                        } finally {
                          try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                              _iterator3.return();
                            }
                          } finally {
                            if (_didIteratorError3) {
                              throw _iteratorError3;
                            }
                          }
                        }
                      }
                    } catch (err) {
                      _didIteratorError2 = true;
                      _iteratorError2 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                          _iterator2.return();
                        }
                      } finally {
                        if (_didIteratorError2) {
                          throw _iteratorError2;
                        }
                      }
                    }

                    return true;
                  });
                }

                return _context.abrupt("return", filteredOutput);

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
      this.cacheQuads(quads, subject, predicate, object, graph);
      return this.getCachedQuads(subject, predicate, object, graph);
    }
  }, {
    key: "getPatternId",
    value: function getPatternId(subject, predicate, object, graph) {
      // tslint:disable:object-literal-sort-keys
      return JSON.stringify({
        s: rdf_string_1.termToString(subject),
        p: rdf_string_1.termToString(predicate),
        o: rdf_string_1.termToString(object),
        g: rdf_string_1.termToString(graph)
      }); // tslint:enable:object-literal-sort-keys
    }
  }, {
    key: "cacheQuads",
    value: function cacheQuads(quads, subject, predicate, object, graph) {
      var patternId = this.getPatternId(subject, predicate, object, graph);
      this.cachedQuads[patternId] = quads.clone();
    }
  }, {
    key: "getCachedQuads",
    value: function getCachedQuads(subject, predicate, object, graph) {
      var patternId = this.getPatternId(subject, predicate, object, graph);
      var quads = this.cachedQuads[patternId];

      if (quads) {
        var quadsOriginal = quads; // Make our iterator lazy to ensure that metadata event is emitted before end event.

        quads = new asynciterator_promiseproxy_1.PromiseProxyIterator(
        /*#__PURE__*/
        _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  return _context2.abrupt("return", quadsOriginal.clone());

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        })));
        quadsOriginal.getProperty('metadata', function (metadata) {
          return quads.emit('metadata', metadata);
        });
        return quads;
      }

      return null;
    }
  }]);

  return RdfSourceQpf;
}();

exports.RdfSourceQpf = RdfSourceQpf;